module.exports = __webpack_public_path__ + "img/tabel-acls.5eb0795e.png";